export const ATTRIBUTE = 'data-scroll-lock-fill-gap'

function updateAttribute(el, { value = true }) {
  if (value) {
    el.setAttribute(ATTRIBUTE, '')
  } else {
    el.removeAttribute(ATTRIBUTE)
  }
}

const scrollLockFillGap = {
  name: 'scroll-lock-fill-gap',

  created: updateAttribute,
  updated: updateAttribute,
}

export { scrollLockFillGap }
